import React from 'react'
import { useDimensions } from 'src/ui/dimensions'

import { GraduateStories as Desk } from './desk'
import { GraduateStories as Mob } from './mob'

type Props = {
  images: TImages
}
export const GraduateStories: React.FC<Props> = ({ images }) => {
  const { isMobile } = useDimensions()
  const Component = isMobile ? Mob : Desk

  return <Component images={images} />
}
